import { Component, OnInit, AfterViewInit, ViewChild, ElementRef, OnDestroy } from '@angular/core';
import { CommonModule } from '@angular/common';
import { faqCategories } from './data/faq.data';
import { AnalyticsService } from '../../../services/analytics.service';

interface FaqCategory {
  id: string;
  title: string;
  questions: {
    id: string;
    question: string;
    answer: string | string[];
    isOpen?: boolean;
  }[];
}

@Component({
  selector: 'app-faq-accordion',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './faq-accordion.component.html',
  styleUrls: ['./faq-accordion.component.scss']
})
export class FaqAccordionComponent implements OnInit, AfterViewInit, OnDestroy {
  @ViewChild('faqAccordion', { static: false }) faqAccordion?: ElementRef;
  activeCategory: string = 'general';
  faqCategories: FaqCategory[] = faqCategories.map(category => ({
    ...category,
    questions: category.questions.map(question => ({
      ...question,
      isOpen: false
    }))
  }));

  constructor(private analyticsService: AnalyticsService) {}

  ngOnInit() {
    // No necesita tracking de página aquí, se maneja en la página padre
  }

  ngAfterViewInit() {
    // Registrar la sección para tracking de analytics
    if (this.faqAccordion?.nativeElement) {
      this.analyticsService.registerSectionForTracking(
        this.faqAccordion.nativeElement,
        'FAQ Accordion',
        'faq-accordion-section'
      );
    }
  }

  ngOnDestroy() {
    // Cleanup si es necesario
  }

  setActiveCategory(categoryId: string): void {
    this.activeCategory = categoryId;
  }

  getActiveCategoryQuestions() {
    return this.faqCategories.find(cat => cat.id === this.activeCategory)?.questions || [];
  }

  isArray(value: any): boolean {
    return Array.isArray(value);
  }
}
